import { useReducerData } from 'store/hooks';

const useCurrenUser = () => {
  const data = useReducerData('loginState', 'profile');

  return data;
};

export default useCurrenUser;
